const STATUS_THRESHOLDS = {
  "90%": { safe: 10, overdue: 14 },
  "75%": { safe: 28, overdue: 35 },
  "50%": { safe: 49, overdue: 56 },
};

const ACTIVE_ESTATUS = new Set(["90%", "75%", "50%"]);

const formatDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const daysBetween = (fromDate, toDate) => {
  const from = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
  const to = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
  return Math.floor((to - from) / (1000 * 60 * 60 * 24));
};

export const getOportunidadDateStatus = (oportunidad) => {
  const createdRaw = oportunidad?.created_at;
  const updatedRaw = oportunidad?.updated_at;
  const estatus = oportunidad?.estatus;

  const createdDate = createdRaw ? new Date(createdRaw) : null;
  const updatedDate = updatedRaw ? new Date(updatedRaw) : null;
  const validCreated = createdDate && !Number.isNaN(createdDate.getTime()) ? createdDate : null;
  const validUpdated = updatedDate && !Number.isNaN(updatedDate.getTime()) ? updatedDate : null;

  const refForUpdate = validUpdated || validCreated;
  const today = new Date();
  const daysSinceUpdate = refForUpdate ? daysBetween(refForUpdate, today) : null;
  const daysSinceCreated = validCreated ? daysBetween(validCreated, today) : null;
  const hasUpdate = !!validUpdated && !!validCreated && daysBetween(validCreated, validUpdated) > 0;

  const isActive = ACTIVE_ESTATUS.has(estatus);
  let severity = "none";
  if (isActive && daysSinceUpdate != null) {
    const thresholds = STATUS_THRESHOLDS[estatus];
    if (daysSinceUpdate >= thresholds.overdue) severity = "overdue";
    else if (daysSinceUpdate >= thresholds.safe) severity = "warning";
    else severity = "safe";
  }

  return {
    isActive,
    severity,
    hasUpdate,
    daysSinceUpdate,
    daysSinceCreated,
    createdLabel: formatDate(validCreated),
    updatedLabel: formatDate(validUpdated),
  };
};
